export default __webpack_public_path__ + "static/media/lion.538ae53e.png";